import type {
    SubscriptionOrderAssistantsChatQuery,
    SubscriptionOrderAssistantsChatRegistrationResponse,
    SubscriptionOrderListQuery,
    SubscriptionOrderResponse,
    SubscriptionOrderTrialCreationParams,
} from 'chaika-frontend-types/frontend-cms';

import { axios } from '@lib/axios';

const BASE_URL = '/api/subscription-order';

export class SubscriptionOrderApi {
    public static async createTrial(params: SubscriptionOrderTrialCreationParams): Promise<void> {
        await axios.post(`${BASE_URL}/trial`, params);
    }

    public static async getList(params: SubscriptionOrderListQuery): Promise<SubscriptionOrderResponse> {
        const { data } = await axios.get<SubscriptionOrderResponse>(BASE_URL, { params });

        return data;
    }

    public static async refund(subscriptionOrderId: string): Promise<void> {
        await axios.delete(`${BASE_URL}/${subscriptionOrderId}`);
    }

    public static async updatePatient(subscriptionOrderId: string, patientId: string): Promise<void> {
        await axios.put(`${BASE_URL}/${subscriptionOrderId}/patient`, {
            patientId,
        });
    }

    public static async activate(subscriptionOrderId: string): Promise<void> {
        await axios.post(`${BASE_URL}/${subscriptionOrderId}/activation`);
    }

    public static async createChat(subscriptionOrderId: string, doctorId: string): Promise<void> {
        await axios.post(`${BASE_URL}/${subscriptionOrderId}/chat`, { doctorId });
    }

    public static async registerInChat(doctorId: string): Promise<string> {
        const res = await axios.post(`${BASE_URL}/chat-registration`, { doctorId });

        return res.data.registrationLink;
    }

    public static async getAssistantsChat({
        patientId,
        assistantId,
    }: SubscriptionOrderAssistantsChatQuery): Promise<
        SubscriptionOrderAssistantsChatRegistrationResponse['assistantPracticeChats']
    > {
        let assistantPracticeChats: SubscriptionOrderAssistantsChatRegistrationResponse['assistantPracticeChats'] = [];

        try {
            const res = await axios.get<SubscriptionOrderAssistantsChatRegistrationResponse>(
                `${BASE_URL}/assistants-chat`,
                { params: { patientId, assistantId } },
            );

            assistantPracticeChats = res.data.assistantPracticeChats;
        } catch {}

        return assistantPracticeChats;
    }

    public static async createAssistantsChat(patientId: string, practiceId: string): Promise<void> {
        await axios.post(`${BASE_URL}/assistants-chat`, { patientId, practiceId });
    }
}
